import React, { Component } from "react";
import PropTypes from "prop-types";
import { Col, Row } from "react-bootstrap";
import { Spinner } from "modules/common/components";
import './style.css';
import { colors } from "modules/common/styles";
import {
  LoaderWrapper,
  TotalCallCount,
  TotalCallItem,
  TotalCallTitle,
} from "../styles/main";

const propTypes = {
  data: PropTypes.array.isRequired,
  loading: PropTypes.bool,
};

function TotalCalls({totalCall}) {
  return (
    <Col
        lg={4}
        md={5}
        className="AgentDashboardTileTheme"
        key={Math.random()}
      >
        <TotalCallItem
          className="total-call-item-agent-tile"
          style={{
            padding: "20px",
            background: colors.colorWhite,
            borderRadius: "20px",
            marginRight: "15px",
            boxShadow: "0px 4px 24px rgba(0, 0, 0, 0.05)",
          }}
        >
          <div style={{display:'flex'}}>
            <label
              style={{
                width: "30px",
                height: "60px",
                minWidth:'30px',
                minHeight:'60px',
                background: totalCall.color,
                opacity: "0.2",
                borderRadius: "30px",
                marginRight: "10px",
              }}
            ></label>
            <span
              style={{
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <TotalCallTitle
                style={{
                  fontStyle: "normal",
                  fontWeight: "700",
                  fontSize: "22px",
                  lineHeight: "30px",
                  color: "#010101",
                }}
              >
                {totalCall.title}
              </TotalCallTitle>
              <span>
                <TotalCallCount
                  style={{
                    fontStyle: "normal",
                    fontWeight: "500",
                    fontSize: "18px",
                    lineHeight: "27px",
                    color: "#B1B1B1",
                  }}
                >
                  {totalCall.count}
                </TotalCallCount>
              </span>
            </span>
          </div>
        </TotalCallItem>
      </Col>
  )
}

export class AgentDashboardTileTheme extends Component {
  render() {
    const { __ } = this.context;
    const { data, loading } = this.props;

    if (loading) {
      return (
        <LoaderWrapper>
          <Spinner objective />
        </LoaderWrapper>
      );
    }

    return (
      <Row>
        {data.map((totalCall) => (
          <TotalCalls totalCall={totalCall} />
        ))}
      </Row>
    );
  }
}

AgentDashboardTileTheme.contextTypes = {
  __: PropTypes.func,
};

AgentDashboardTileTheme.propTypes = propTypes;

export default AgentDashboardTileTheme;



// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/AgentDashboardTileTheme.js